import React, { Component, push } from "react";
import {
  Grommet,
  Box,
  Text,
  DataTable,
  Spinner,
  Layer,
  Button,
  Heading,
} from "grommet";
import { Close } from "grommet-icons";
import Alert from "@material-ui/lab/Alert";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import { callApiGetJson } from "./GlobalSettings";

class TmeCRSeatlst extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSeatLoader: true,
      EvtSeats: undefined,
    };

    this.loadTMECRSeatsForEvt = this.loadTMECRSeatsForEvt.bind(this);
  }

  loadTMECRSeatsForEvt() {
    //console.log()
    this.setState({ showSeatLoader: true });
    //console.log(date);
    var endpoint = "/AllContent/getEventSeatsTME_CR/" + this.props.evtID;
    let token = auth.getToken();
    callApiGetJson(endpoint, token).then((data) => {
      if (data !== undefined) {
        console.log("data is ", data);
        this.setState({ EvtSeats: data, showSeatLoader: false });
      } else {
        console.log("erroneous data is ", data);
      }
    });
  }

  componentDidMount() {
    this.loadTMECRSeatsForEvt();
    /*  this._evtInterval = setInterval(() => {
      console.log("Interval started! for upcoming Demo Refresh");
      this.loadUpcomingEventsData();
    }, 60000); */
  }

  render() {
    console.log("Event Seats Loaded are ", this.state.EvtSeats);
    var ghorChakra = "";
    if (this.state.showSeatLoader) {
      ghorChakra = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner
              size="small"
              border={[
                { side: "all", color: "yellow", size: "medium" },
                { side: "right", color: "brand", size: "medium" },
                { side: "top", color: "red", size: "medium" },
                { side: "left", color: "brand", size: "medium" },
              ]}
            />
            <Text size="small">Fetching Event Seats for you...</Text>
          </Box>
        </Layer>
      );
    }

    var columns = [
      {
        property: "SeatName",
        header: "Seat",
        // primary: true,
      },
      {
        property: "DataCenterName",
        header: "Data Center",
      },
      {
        property: "SeatStatus",
        header: "Status",
      },
      {
        property: "SeatURL",
        header: "Url",
      },
      {
        property: "SeatUid",
        header: "UserId",
      },
      {
        property: "SeatPwd",
        header: "Password",
      },
    ];

    var data_d = this.state.EvtSeats ? this.state.EvtSeats : null;

    console.log("Data to render is ", data_d);

    return (
      <Layer position="center" full="horizontal" onEsc={this.props.hide}>
        {ghorChakra}
        {data_d && !this.state.showSeatLoader && (
          <Box pad="large">
            <Box
              align="end"
              //justify="between"
              direction="row"
              gap="medium"
              fill="horizontal"
              justify="end"
              //alignSelf="end"
            >
              <Box align="start" justify="start" direction="row">
                <Alert severity="success">
                  Press <strong>[ESC]</strong> key or click <strong>[X]</strong>{" "}
                  to close
                </Alert>
              </Box>
              <Button icon={<Close />} secondary onClick={this.props.hide} />
            </Box>
            <br />
            <Box
              align="center"
              //justify="between"
              direction="row"
              gap="medium"
              fill="horizontal"
              justify="between"
              background={{ color: "brand" }}
              elevation="large"
              //alignSelf="end"
            >
              <Heading size="small" level="1" margin="small" textAlign="center">
                {"Seats for your Demo-Event ID " + this.props.evtID}
              </Heading>
            </Box>
            <br />
            <DataTable
              columns={columns}
              data={data_d}
              sortable
              step={5}
              paginate
              border={true}
              background={{
                header: "brand",
                body: ["white", "light-2"],
              }}
            />
          </Box>
        )}
      </Layer>
    );
  }
}
export default TmeCRSeatlst;
